<script setup lang="ts">
import type { ButtonProps } from '#ui/types';
import type { PropType } from 'vue';

defineProps({
    icon: { type: String, default: undefined },
    title: { type: String, required: true },
    description: { type: String, default: null },
    actions: { type: Array as PropType<ButtonProps[]>, default: undefined },
});
</script>

<template>
    <div class="text-inverted inset-x-0 w-full items-center justify-center ring-1 ring-neutral-300">
        <BaseWidthContainer
            class="relative flex min-h-(--header-height) flex-col flex-nowrap justify-between gap-4 py-4 md:flex-row md:items-center md:py-3"
        >
            <div class="flex grow flex-row items-start gap-3 lg:items-center">
                <UIcon v-if="icon" class="h-6 w-6" :name="icon" />
                <div class="flex grow flex-col gap-1 lg:flex-row lg:gap-3">
                    <div class="text-sm leading-5 font-bold tracking-normal md:text-base md:leading-6">{{ title }}</div>
                    <div class="text-sm leading-5 font-medium tracking-normal md:text-base md:leading-6">{{ description }}</div>
                </div>
            </div>
            <div class="flex flex-col gap-1 md:flex-row">
                <UButton v-for="(action, index) in actions" :key="index" v-bind="action" />
            </div>
        </BaseWidthContainer>
    </div>
</template>
